import { ExternalLink, LifeBuoy } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import CTABand from "../components/CTABand";
import { RESOURCES } from "../data/resources";
import { breadcrumbSchema } from "../lib/schema";

export default function Resources() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Resources", path: "/resources" },
  ];
  return (
    <>
      <SEO
        title="Mental Health Resources for New Jersey"
        description="Trusted mental health organizations, educational materials, and crisis resources curated by NJ Therapy Online."
        path="/resources"
        schema={breadcrumbSchema(crumbs)}
      />
      <PageHero
        crumbs={crumbs}
        eyebrow="Resources"
        title="Mental health"
        accent="resources"
        underline
        body="Trusted organizations and educational materials to support you between sessions."
        testid="resources-hero"
      />

      <section className="section" data-testid="resources-list">
        <div className="container-site">
          <div className="rounded-2xl bg-[var(--sage-tint)] p-6 flex flex-col sm:flex-row gap-4 sm:items-center" data-testid="resources-crisis-banner">
            <LifeBuoy className="h-6 w-6 text-[var(--sage)] shrink-0" />
            <p className="text-[15px] text-[var(--ink)] leading-relaxed">
              <strong>In a crisis?</strong> Call <a href="tel:911" className="font-semibold underline">911</a> or call/text{" "}
              <a href="tel:988" className="font-semibold underline">988</a> for the Suicide & Crisis Lifeline — free, confidential, 24/7.
            </p>
          </div>

          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {RESOURCES.filter((c) => !c.isCrisis).map((cat) => (
              <div key={cat.category} className="card p-6" data-testid="resource-card">
                <h2 className="text-lg">{cat.category}</h2>
                <p className="mt-2 text-sm text-body leading-relaxed">{cat.description}</p>
                <ul className="mt-4 space-y-2">
                  {cat.links.map((l) => (
                    <li key={l.url + l.name}>
                      <a href={l.url} target="_blank" rel="noopener noreferrer" className="inline-flex gap-2 text-sm font-medium text-[var(--sage)] hover:underline">
                        <ExternalLink className="h-3.5 w-3.5 mt-0.5 shrink-0" /> {l.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTABand />
    </>
  );
}
